import { LiveKitRoom } from "@livekit/components-react";

import { useGetVoiceChatTokenQuery } from "@/pages/Private/redux/course-progress/course-progress.api";
import { PARSED_ENV } from "@/constants";

import { UserStatus } from "@/enum";
import { UserLanguage } from "@/enum/user.enum";

import VoiceChatContent from "./VoiceChatContent";

interface IVoiceChatProps {
	courseProgressId: string;
	user: {
		status: UserStatus;
		id: number | string;
		email: string;
		is2FAEnabled: boolean;
		isBlocked: boolean;
		autoAccept: boolean;
		firstName?: string | undefined;
		lastName?: string | undefined;
		userlanguage?: UserLanguage | undefined;
	};
	classname?: string;
	onDisconnect: () => void;
}

export default function VoiceChat({
	courseProgressId,
	user,
	onDisconnect,
	classname,
}: IVoiceChatProps) {
	const userId = user.id;
	const userName = `${user.firstName} ${user.lastName}`;

	const { data } = useGetVoiceChatTokenQuery({
		courseProgressId,
		userId,
		userName,
	});

	const serverUrl = PARSED_ENV.VITE_LIVEKIT_URL;
	const token = data?.token;

	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	const LiveKitRoomComponent = LiveKitRoom as any;

	return (
		<>
			{data?.token && (
				<div className={classname}>
					<LiveKitRoomComponent
						audio={true}
						serverUrl={serverUrl}
						style={{ minWidth: "100%", fontColor: "#000" }}
						token={token}
						video={false}
						onDisconnected={onDisconnect}
					>
						<VoiceChatContent />
					</LiveKitRoomComponent>
				</div>
			)}
		</>
	);
}
